import { SxProps, Theme, Typography, TypographyProps } from "@mui/material";

/**
 * One section of the exceedance drawer. The drawer stacks half a dozen dense
 * tables, so each is separated by a rule plus generous space above its heading —
 * enough to show where one ends and the next begins without boxing the content in,
 * which would indent it out of line with the drawer title.
 *
 * The rule sits on top rather than between siblings so conditionally-rendered
 * sections can't leave a stray divider behind. It also separates the first section
 * from the identity block (chips, meta line, owner) above it, which is wanted.
 */
export const drawerSectionSx: SxProps<Theme> = {
  borderTop: 1,
  borderColor: "divider",
  pt: 2.5,
};

/**
 * A section's heading. Worth a component rather than another `sx` constant: the
 * weight is doing real work. `subtitle1` sizes it a clear tier below the drawer's
 * `h6` title, but MUI defaults that variant to weight 400 — lighter than the
 * `subtitle2` this replaced — so omitting the override would silently make a
 * heading recede instead of stand out.
 */
export function DrawerSectionHeading({ sx, children, ...rest }: TypographyProps) {
  return (
    <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 600, ...sx }} {...rest}>
      {children}
    </Typography>
  );
}
